import React from "react";
import { CheckboxV2 } from "@shopflo/ui";
import { useLocale } from "lib/hooks/useLocale";

// Local prop facade: checkout-ui doesn't have @radix-ui/react-checkbox as a direct dep, so CheckboxV2's Radix types don't resolve here.
type ConsentCheckboxProps = {
  size?: "sm" | "md";
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
};
const ConsentCheckbox = CheckboxV2 as unknown as React.ComponentType<ConsentCheckboxProps>;

interface ConsentCheckboxRowProps {
  id: string;
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  /** Adds the "Manage preferences" link after the label */
  onManagePreferences?: () => void;
  className?: string;
}

// A consent checkbox under the phone input, e.g. "Keep me updated ... Manage preferences".
const ConsentCheckboxRow: React.FC<ConsentCheckboxRowProps> = ({
  id,
  label,
  checked,
  onCheckedChange,
  onManagePreferences,
  className = "",
}) => {
  const { t } = useLocale();

  return (
    <div className={`flex w-full items-start gap-3 py-1 ${className}`}>
      <div className="flex h-[22px] shrink-0 items-center">
        <ConsentCheckbox
          id={id}
          size="md"
          checked={checked}
          onCheckedChange={(value) => onCheckedChange(Boolean(value))}
        />
      </div>
      <p className="flex-1 text-left text-xs leading-[18px] tracking-[-0.12px] text-[#71717b]">
        <label htmlFor={id}>{label}</label>
        {onManagePreferences && (
          <>
            {" "}
            <button
              type="button"
              onClick={onManagePreferences}
              className="font-medium text-[#52525c] underline decoration-[rgba(60,60,60,0.5)]">
              {t("consent_manage_preferences")}
            </button>
          </>
        )}
      </p>
    </div>
  );
};

export default ConsentCheckboxRow;
